const baseFont = ['Pretendard GOV Variable', 'system-ui', 'sans-serif'].join(',');

const typography = {
  fontFamily: baseFont,
  h1: { fontSize: '70px', fontWeight: '700', lineHeight: 1.5 },
  h2: { fontSize: '60px', fontWeight: '700', lineHeight: 1.5 },
  h3: { fontSize: '48px', fontWeight: '700', lineHeight: 1.5 },
  h4: { fontSize: '40px', fontWeight: '700', lineHeight: 1.5 },
  h5: { fontSize: '32px', fontWeight: '700', lineHeight: 1.5 },
  h6: { fontSize: '30px', fontWeight: '700', lineHeight: 1.5 },
  subtitle1: { fontSize: '24px', fontWeight: '700', lineHeight: 1.5 },
  subtitle2: { fontSize: '20px', fontWeight: '700', lineHeight: 1.5 },
  subtitle3: { fontSize: '19px', fontWeight: '700', lineHeight: 1.5 },
  body1: { fontSize: '17px', lineHeight: 1.5 },
  body2: { fontSize: '15px', lineHeight: 1.5 },
  body3: { fontSize: '14px', lineHeight: 1.5 },
};

export default typography;
